import { TextField, TextFieldProps } from "@mui/material"
import { Box } from "@mui/system"



export const SearchBox = (props: TextFieldProps) => {
    return <Box sx={{ width: '100%', minWidth: { xs: 'auto', sm: '240px' }, maxWidth: '400px' }}>
        <TextField
            hiddenLabel
            {...props}
            sx={{
                '& .MuiOutlinedInput-input': {
                    padding: '5px 7px',
                },
                '& .MuiOutlinedInput-root': {
                    fontSize: '14px',
                },
                ...props.sx,
            }}
        />
    </Box>
}